import React, { useState } from "react";
import Header from "./Header";
import Expand_down from "../img/Expand_down.svg";
import CalendarLogo from "../img/CalendarLogo.svg";
import Search from "../img/Search.svg";
import Arow_down from "../img/Arow_down.svg";
import group_arrow from "../img/group_arrow.svg";
import group_arrows from "../img/group_arrows.svg";
import refreshLogo from "../img/refreshLogo.svg";
import BackgroundImg from "../img/BackgroundNetImg.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SalesReport = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selected, setSelected] = useState("");

  return (
    <div className="">
      <Header></Header>
      <div
        className=" bg-white min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url(${BackgroundImg})`,
          backgroundPosition: "50% 0%",
        }}
      >
        <div className="sm:px-8 sm:py-6 px-5 py-5">
          <div className="w-full flex flex-col sm:flex-row justify-between sm:items-center">
            <span className="font-semibold text-2xl ">Sales Report</span>
            <div className="flex gap-3">
              <select
                value={selected}
                onChange={(e) => setSelected(e.target.value)}
                name=""
                id=""
                className={`border-[1px] border-[#8C8C8C4D] cursor-pointer px-1 text-[#8C8C8C] bg-no-repeat bg-right text-left rounded-md w-24 appearance-none focus:outline-none ${
                  selected === "" ? "text-[#9CA3AF]" : "text-black"
                }`}
                style={{ backgroundImage: `url(${Expand_down})` }}
              >
                <option value="" disabled hidden>
                  All
                </option>
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
                <option value="option3">Option 3</option>
              </select>
              <div className="relative">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="DD-MM-YYY"
                  className="border-[1px] border-[#8C8C8C4D] w-32 focus:outline-none cursor-pointer p-2 rounded-md text-sm"
                />
                <img
                  src={CalendarLogo}
                  alt=""
                  className="absolute right-2 top-2"
                />
              </div>
              <button className="text-sm font-semibold rounded-md bg-primary py-2 text-white px-4">
                Export
              </button>
            </div>
          </div>

          <div className="w-full flex flex-wrap sm:flex-row bg-white flex-col justify-between gap-4 mt-10">
            <div
              className="flex flex-col gap-2 border-1 rounded-md  shadow py-4 px-3 sm:w-[48%] lg:w-[23%]"
              style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
            >
              <span className="font-semibold text-xl">Total Revenue</span>
              <span className="text-[#8C8C8C] text-xs">Value</span>
              <div className="bg-[#F1EFFF] h-10 w-full flex justify-center items-center">
                <span className="text-lg">₹0</span>
              </div>
            </div>

            <div
              className="flex flex-col gap-2 border-1 rounded-md  shadow py-4 px-3 sm:w-[48%] lg:w-[23%]"
              style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
            >
              <span className="font-semibold text-xl">Units Sold</span>
              <span className="text-[#8C8C8C] text-xs">Value</span>
              <div className="bg-[#F1EFFF] h-10 w-full flex justify-center items-center">
                <span className="text-lg">₹0</span>
              </div>
            </div>

            <div
              className="flex flex-col gap-2 border-1 rounded-md bg-white  shadow py-4 px-3 sm:w-[48%] lg:w-[23%]"
              style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
            >
              <span className="font-semibold text-xl">Avg. Unit Price</span>
              <span className="text-[#8C8C8C] text-xs">Value</span>
              <div className="bg-[#F1EFFF] h-10 w-full flex justify-center items-center">
                <span className="text-lg">₹0</span>
              </div>
            </div>

            <div
              className="flex flex-col gap-2 border-1 rounded-md bg-white  shadow py-4 px-3 sm:w-[48%] lg:w-[23%]"
              style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
            >
              <span className="font-semibold text-xl">Total Discounts</span>
              <span className="text-[#8C8C8C] text-xs">Value</span>
              <div className="bg-[#F1EFFF] h-10 w-full flex justify-center items-center">
                <span className="text-lg">₹0</span>
              </div>
            </div>
          </div>

          <div className="mt-10 overflow-x-auto w-full ">
            <div className="min-w-[1000px]">
              <div className="relative h-24 bg-[#F1EFFF]  rounded-md">
                <div className=" rounded-t-md px-3 py-2  flex justify-between items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="h-8 rounded w-64 px-8 text-sm"
                      placeholder="Search"
                    />
                    <img
                      src={Search}
                      alt=""
                      className="absolute left-1 top-2"
                    />
                  </div>

                  <div className="flex gap-5">
                    <select
                      name=""
                      id=""
                      className="appearance-none text-sm font-semibold cursor-pointer focus:outline-none py-1 bg-no-repeat bg-right text-left rounded-md w-36 px-2"
                      style={{
                        backgroundImage: `url(${Arow_down})`,
                        backgroundPosition: "94% center",
                      }}
                    >
                      <option value="">All Categories</option>
                      <option value="">Categories</option>
                      <option value="">Categories</option>
                      <option value="">Categories</option>
                    </select>

                    <select
                      name=""
                      id=""
                      className="appearance-none text-sm font-semibold cursor-pointer focus:outline-none py-1 bg-no-repeat bg-right text-left rounded-md w-36 px-2"
                      style={{
                        backgroundImage: `url(${Arow_down})`,
                        backgroundPosition: "94% center",
                      }}
                    >
                      <option value="">Discount Applied</option>
                      <option value="">Categories</option>
                      <option value="">Categories</option>
                      <option value="">Categories</option>
                    </select>

                    <div className="text-sm font-semibold flex justify-center items-center gap-2">
                      <span>Revenue slider</span>
                      <div className="flex px-2 bg-white py-1 rounded-md gap-2">
                        <span>Min</span>
                        <div className="flex flex-col gap-1">
                          <img
                            src={group_arrow}
                            alt=""
                            className="cursor-pointer"
                          />
                          <img
                            src={group_arrows}
                            alt=""
                            className="cursor-pointer"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-center items-center py-1 px-2 bg-white rounded-md">
                      <img src={refreshLogo} alt="" />
                    </div>
                  </div>
                </div>
                <div className="flex absolute bottom-0 items-center justify-between py-2 px-5 bg-[#CEC7FF4D] rounded-md text-sm font-semibold w-full">
                  <span className="w-20 text-left">No:</span>
                  <span className="flex-1 text-left">App Icon</span>
                  <span className="w-52 text-left">App Name</span>
                  <span className="flex-1 text-left">Platform</span>
                  <span className="flex-1 text-left">Units</span>
                  <span className="flex-1 text-left">Revenue</span>
                  <span className="flex-1 text-left">Discounts</span>
                  <span className="flex-1 text-left">Net Revenue</span>
                  <span className=" text-right">View</span>
                </div>
              </div>
            </div>

            {/* <div
              className="mt-2 min-w-[1000px] bg-white  border  rounded-md"
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              <div className="flex items-center justify-between py-2 px-5 rounded-md text-sm font-semibold w-full">
                <span className="w-20 text-left">1</span>
                <span className="flex-1 text-left">App Icon</span>
                <span className="w-52 text-left">SkillConnect</span>
                <span className="flex-1 text-left">Android</span>
                <span className="flex-1 text-left">2,345</span>
                <span className="flex-1 text-left">₹234,500</span>
                <span className="flex-1 text-left">₹23,450</span>
                <span className="flex-1 text-left">₹211,050</span>
                <span className="underline text-[#8F61DB] text-right">
                  View
                </span>
              </div>
              <div className="flex items-center justify-between py-2 px-5 rounded-md text-sm font-semibold w-full">
                <span className="w-20 text-left">2</span>
                <span className="flex-1 text-left">App Icon</span>
                <span className="w-52 text-left">JobFinder</span>
                <span className="flex-1 text-left">Android</span>
                <span className="flex-1 text-left">2,345</span>
                <span className="flex-1 text-left">₹234,500</span>
                <span className="flex-1 text-left">₹23,450</span>
                <span className="flex-1 text-left">₹211,050</span>
                <span className="underline text-[#8F61DB] text-right">
                  View
                </span>
              </div>
              <div className="flex items-center justify-between py-2 px-5 rounded-md text-sm font-semibold w-full">
                <span className="w-20 text-left">3</span>
                <span className="flex-1 text-left">App Icon</span>
                <span className="w-52 text-left">TaskMaster</span>
                <span className="flex-1 text-left">Android</span>
                <span className="flex-1 text-left">2,345</span>
                <span className="flex-1 text-left">₹234,500</span>
                <span className="flex-1 text-left">₹23,450</span>
                <span className="flex-1 text-left">₹211,050</span>
                <span className="underline text-[#8F61DB] text-right">
                  View
                </span>
              </div>
            </div> */}

            <div className="flex justify-center items-center mt-5">
              <span>No data..</span>

            </div>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesReport;
